import { IUser } from 'app/shared/model/user.model';

export interface IParent {
  id?: string;
  lastName?: string | null;
  firstName?: string | null;
  telephone?: number;
  activated?: boolean;
  user?: IUser | null;
}

export const defaultValue: Readonly<IParent> = {
  id: null,
  lastName: '',
  firstName: '',
  telephone: null,
  activated: true,
  user: {},
};
